import Vue from 'vue'

const state = { now: Date.now() }

const getters = {
    currentTime: state => state.now
}

const actions = {
    tick ({commit}) {
        setInterval(() => {
            commit('TICK')
        }, 10000)
    }
}

const mutations = {
    TICK(state) {
        state.now = Date.now()
    }
}

export default {
    state,
    getters,
    actions,
    mutations
  }



// WEBPACK FOOTER //
// ./src/store/modules/time.js